import React from 'react';

import { Row } from '../Layout/Grid';
import Text from '../Text';
import FloatingLabel from '../FloatingLabel';
import { AttachmentProps } from './interface';

import attachmentIcon from 'img/icon-anexo.svg';

export const Attachment: React.FC<AttachmentProps> = (props) => {

  const { addFile, setFiles, files, fileTypesAccept } = props;

  const removeFile = (id: number) => {
    const _files: Array<File> = files;

    _files.splice(id, 1);

    return setFiles([..._files]);
  };

  return (
    <>
      <Row className="align-center">
        <img src={attachmentIcon} alt="Ícone de anexo" />
        <Text className="ml-1 color-blue-gray" size={12}>
          Anexar Arquivos
        </Text>
        <input
          onChange={addFile}
          id="open_files_contact_president"
          className="d-none"
          type="file"
          multiple
          accept={fileTypesAccept.toString()}
        />
      </Row>
      <Row className="mt-1 align-center align-sm-none flex-sm-column">
        <label
          className="button outline"
          htmlFor="open_files_contact_president"
        >
          <Text className="px-2 color-primary font-bold">
            Selecionar Arquivo
          </Text>
        </label>

        <Row className="ml-2 ml-sm-0 my-sm-2 align-center flex-wrap word-break">
          {files.map((file, _) => (
            <FloatingLabel
              key={_}
              label={file.name}
              index={_}
              onRemove={removeFile}
            />
          ))}
        </Row>
      </Row>
    </>
  );
};